import { setupEntryPoint } from './setupEntryPoint'
import App from '@/layouts/BaseLayout.vue'
import router from '@/routers/tenant'

setupEntryPoint(App, router)
